var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _rect4, _rect5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMccsGroups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 41.0359L0 41.0359C6.39855e-06 29.1633 9.35429 19.5416 20.8947 19.5417L42.4761 19.5417L62 19.6117C62 41.0359 62 29.6367 62 41.0359Z",
    fill: "#3388FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3646 42.7026C19.7774 45.7387 20.6189 48.6345 21.8243 51.3239L43.1705 51.7988C45.1431 51.8446 47.0485 51.0647 48.4383 49.6196L59.8705 37.3246C61.2603 35.8795 62.0224 33.9068 61.9776 31.8882L62 2.11448C62 0.944618 61.0361 0.00414145 59.8929 0.00414145H59.8481H37.1854C35.2128 -0.0417355 34.092 0.279403 32.5228 1.67865L21.0009 13.9737C19.6112 15.3958 19.2973 17.3686 19.3646 19.4101V42.7026Z",
    fill: "#003C8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.8147e-06 40.634H62C62 52.5066 52.6457 62.1283 41.1053 62.1283H19.5239L9.96413 62.094C4.45532 62.0742 -3.8147e-06 57.6006 -3.8147e-06 52.0918C-3.8147e-06 44.5463 -3.8147e-06 49.5253 -3.8147e-06 40.634Z",
    fill: "#1760CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.8147e-06 40.6941H62C62 52.5335 52.6457 62.1284 41.1053 62.1284H19.5239L9.96423 62.0942C4.45538 62.0745 -3.8147e-06 57.5991 -3.8147e-06 52.0903C-3.8147e-06 44.6085 -3.8147e-06 49.5489 -3.8147e-06 40.6941Z",
    fill: "#1760CE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5176,
    y: 31.3748,
    width: 12.0976,
    height: 7.14476,
    rx: 3.57238,
    fill: "#7B4E30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.3445,
    height: 7.00374,
    rx: 3.50187,
    transform: "matrix(0.49 -0.871723 0.860135 0.510067 15.7266 55.4934)",
    fill: "#7B4E30"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.9841,
    height: 7.09806,
    rx: 3.54903,
    transform: "matrix(0.860134 0.510067 -0.49 0.871723 22.5312 48.1494)",
    fill: "#7B4E30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5999 34.1994C49.5999 32.9648 49.4103 31.7374 49.0376 30.5603C48.7466 29.6435 48.2093 28.8443 47.4705 28.2566L45.2346 26.094L39.9219 57.4688H44.7617C47.8092 52.5021 49.5999 41.2566 49.5999 34.9091V34.1994Z",
    fill: "#AA6C44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0977,
    y: 41.626,
    width: 12.0976,
    height: 7.14476,
    rx: 3.57238,
    fill: "#AA6C44"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5176,
    y: 44.4216,
    width: 13.0049,
    height: 4.34898,
    rx: 2.17449,
    fill: "#7B4E30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3665 5.28101H20.6348C18.4256 5.28101 16.6348 7.07187 16.6348 9.281V52.8475C16.6348 55.0566 18.4256 56.8475 20.6348 56.8475H41.3665C43.5756 56.8475 45.3665 55.0566 45.3665 52.8475V9.28101C45.3665 7.07187 43.5756 5.28101 41.3665 5.28101Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4581 7.14478H19.541C18.4364 7.14478 17.541 8.0402 17.541 9.14477V51.1197C17.541 52.2243 18.4364 53.1197 19.541 53.1197H42.4581C43.5627 53.1197 44.4581 52.2243 44.4581 51.1197V9.14478C44.4581 8.04021 43.5627 7.14478 42.4581 7.14478Z",
    fill: "#AFD0FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3957 39.1944L31.8755 39.3595C30.7732 42.1615 32.431 45.5384 32.714 46.1149C32.7419 46.1717 32.7565 46.2013 32.7537 46.2005L39.9214 62.1284L35.9897 62.1284L26.9244 46.3417C26.0554 44.7496 25.8723 42.8632 26.4691 41.2168C26.6484 40.8014 26.8901 40.4051 27.1986 40.0817C28.3056 38.9757 29.9208 38.636 31.3957 39.1944Z",
    fill: "#003C8B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6015 60.2823C47.0056 61.4689 44.1303 62.1284 41.1047 62.1284H26.9059C26.6248 61.5754 26.4628 61.0022 26.4628 60.4199C26.4628 59.1252 26.3074 58.6926 26.2656 58.6051C26.3562 58.7366 27.0896 59.5028 30.0921 57.7794C30.8235 57.3596 31.0695 57.349 31.2636 57.3405C31.4679 57.3317 31.6148 57.3253 32.2092 56.8475H35.3859L29.2529 45.4154C27.8708 43.0026 28.2824 40.1085 30.1666 38.9621C32.0507 37.8157 34.7037 38.8633 36.0858 41.276L42.8151 52.0984C46.0486 52.9622 46.4825 47.8366 46.75 44.6764L46.75 44.6764C46.7931 44.1669 46.8319 43.7086 46.8775 43.3346L47.936 42.8686H48.2384C49.0934 47.2229 50.1599 55.0269 49.6015 60.2823Z",
    fill: "#AA6C44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0554 62.0361C42.4132 62.0971 41.7626 62.1283 41.1049 62.1283L34.1752 62.1282C37.5021 61.041 36.746 59.3325 36.746 59.3325L29.028 45.0147C27.769 42.8209 28.2815 40.1064 30.1668 38.9619C30.6787 38.6512 31.2398 38.489 31.8109 38.4614C31.4006 38.9293 31.1508 39.5487 31.1508 40.228C31.1508 40.9111 31.4031 41.5338 31.8176 42.0026L43.0554 62.0361Z",
    fill: "#7B4E30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccsGroups);
export default __webpack_public_path__ + "static/media/mccs_groups.728d78f3.svg";
export { ForwardRef as ReactComponent };